import { useState } from 'react'
import { Button, Flex, Text, Tooltip, rem } from '@mantine/core'
import ImageObserved from '../pipeline/Image'
import { PipelineParameters } from '../pipeline/Pipeline'
import { observer } from 'mobx-react'
import { useStore } from '../../../hooks/use-store'
import { priceMap } from '../pipeline/Router'
import { useHistory } from 'react-router-dom'

function Outpaint(model: {
  buy: (params: PipelineParameters[]) => Promise<void>;
  loading: boolean
}) {

  const history = useHistory()
  const {
    dataStore: { spaceStore },
  } = useStore();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [enlargeParams, setEnlargeParams] = useState({
    url: '',
    left: 250,
    right: 250,
    bottom: 250,
    top: 250,
  });
  return (
    <Flex w={'100%'} mt={12} pt={32} pb={32} pl={40} pr={40} style={{ borderRadius: '4px', background: 'rgba(32, 32, 32, 1)' }} gap={32} pos='relative'>

      <Flex pos='absolute' top='0' right='0' style={{ cursor: 'pointer' }} onClick={() => {
        history.push('/history')
      }}>
        <svg width="40" height="40" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.17157 11.2944L10.8284 5.63758" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10.8284 11.2945L5.17157 5.6377" stroke="#BDBDBD" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      </Flex>
      <Flex direction={'column'} w={'40%'} gap={12}>

        <Text fz={32} fw={800} color='#fff' lh={1.2} mb={12}>Expand Your Frame


        </Text>
        <Text fz={16} color='#fff' lh={1.4} maw={440}>
          Add more space around your image, seamlessly and in full resolution.
          <Tooltip
            label={
              <Text fw={500}>
                Generated visuals can be extended in all directions.
                The AI analyzes the scene and expands it naturally. Perfect for wider compositions, flexible cropping, or adding more layout freedom in post-production.
              </Text>
            }
            multiline
            w={320}

            withArrow
            position="bottom"
            color='dark'
          >
            <span style={{ marginLeft: 4, cursor: 'pointer', display: 'inline-block' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="#4badf4" class="icon icon-tabler icons-tabler-filled icon-tabler-info-square-rounded"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z" /></svg>
            </span>
          </Tooltip>
        </Text>

        {/* {
          [{
            top: 250,
            left: 0,
            right: 0,
            bottom: 0,

          }, {
            top: 0,
            left: 250,
            right: 0,
            bottom: 0,

          },
          {
            top: 0,
            left: 0,
            right: 250,
            bottom: 0,

          },
          {
            top: 0,
            left: 0,
            right: 0,
            bottom: 250,

          },
          ].map(itm => (
            <Button
              size="lg"
              style={{
                border: '1px solid black',
                fontSize: '14px',
              }}
              color="rgba(255, 255, 255, 1)"
              variant={
                enlargeParams.left === itm.left && 
                enlargeParams.top === itm.top &&
                enlargeParams.right === itm.right &&
                enlargeParams.bottom === itm.bottom
                ? "default" : 'outline'}
              onClick={() => {
                setEnlargeParams({
                  ...enlargeParams,
                  left: itm.left,
                  right: itm.right,
                  top: itm.top,
                  bottom: itm.bottom,
                })
              }}
            >{itm.left === 250 ? 'Left' : itm.top === 250 ? 'Top' : itm.right === 250 ? 'Right' : 'Bottom'}</Button>
          ))
        } */}
        {/* <Button
          size="lg"
          style={{
            border: '1px solid black',
            fontSize: '14px',
          }}
          color="rgba(255, 255, 255, 1)"
          variant={enlargeParams.left === 250 && enlargeParams.top === 250 && enlargeParams.right === 250 && enlargeParams.right === 250 ? "default" : 'outline'}
          onClick={() => {
            setEnlargeParams({
              ...enlargeParams,
              left: 250,
              right: 250,
              top: 250,
              bottom: 250,
            })
          }}
        >From all side</Button> */}

        <Flex gap={12} mt={32}>
          <Tooltip
            p={12}
            label={
              <span>Generation cost:
                &nbsp;
                <span style={{
                  color: '#f53c02',
                  fontWeight: 700
                }}>{priceMap.OUTPAINT} credits
                </span>
              </span>
            }
            withArrow
            position="right"
            color='dark'
          >

            <Button
              styles={{
                root: {
                  color: 'rgba(230, 230, 230, 1)',
                  height: rem(36),

                  fontSize: '14px',
                  background: '#f53c02 !important',
                  border: 'none',
                  position: 'relative',
                }
              }}
              variant="default"
              onClick={async () => {
                const pipeline: PipelineParameters = {
                  provider: 'replicate',
                  type: 'enlarge',
                  outpaintUp: enlargeParams.top,
                  outpaintDown: enlargeParams.bottom,
                  outpaintLeft: enlargeParams.left,
                  outpaintRight: enlargeParams.right,
                  inputSrc: spaceStore.selectedImage!,
                  outputSrc: '',
                  size: 1,
                  credits: priceMap.OUTPAINT,
                }
                await model.buy([pipeline]);

              }}
            >
              Enlarge Image
            </Button>
          </Tooltip>
        </Flex>
      </Flex>
      <Flex justify={'center'} direction={'column'} align={'center'} w={'60%'}>
        <ImageObserved
          width={'100%'}
          height={'100%'}
          dark
          src={spaceStore.selectedImage!}
        />
      </Flex>
    </Flex>
  )
}

export default observer(Outpaint);